<template>
  <bim-select
    :value="lang"
    :options="[
      {
        value: 'ru',
        label: 'RUS'
      },
      {
        value: 'en',
        label: 'EN'
      }
    ]"
    @change="changeLang"
  />
</template>

<script>
import bimSelect from '@/components/form/bimSelect/bimSelect'

export default {
  name: 'ChangeLanguage',
  props: {
    lang: String
  },
  components: {
    bimSelect
  },
  methods: {
    changeLang (lang) {
      this.$emit('changeLang', lang)
    }
  }
}
</script>
